// extracted by mini-css-extract-plugin
export var divider = "_mx-0";
export var systemMessage = "_mx-1";
export var systemMessageWrapper = "_mx-2";